import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";

type ArticleOfferSliderHitAction = "carousel_offer_click" | "carousel_right_arrow" | "carousel_left_arrow" | "carousel_more_offers";

export const gtmArticleOfferSliderHit = (action: ArticleOfferSliderHitAction) => {
    hitGoogleTagManager({
        event: "blog",
        blog_action: action
    });
};
